import React from 'react';
// import PropTypes from 'prop-types'

import {Grid} from '@material-ui/core';

// Components
import {T} from 'Actions/translate';
import ProductImage from 'Components/lto/commonOrder/ProductImage';
import {OrderTypeEnum} from 'Utils/constant';

class ProductItem extends React.Component {
    render() {
        const {item, orderType} = this.props;

        console.log('item.productImage================', item.productImage);
        return (
            <div>
                <Grid className="top-content" container spacing={0}>
                    <Grid className="left-content-grid" item xs={3}>
                        <div className="image-box">
                            <ProductImage
                                src={
                                    item.productImage
                                        ? item.productImage + '-250.jpg'
                                        : item.productImage
                                }
                                alt={item.productName}
                            />
                        </div>
                    </Grid>
                    <Grid className="right-content-grid" item xs={9}>
                        <div className="details">
                            <div className="sku row text-ellipsis">
                                <div>
                                    <label>{T('product_sku_colon')} </label>
                                    <span>{item.sku}</span>
                                </div>

                                {/* <div>
                                    <label>
                                        {T('lto_history_detail_list_price')}{' '}
                                    </label>
                                    <span>
                                        <i className="rmb"></i>{' '}
                                        <label className='line-through'>{util.toMoney(item.listPrice)}</label>
                                    </span>
                                </div> */}
                            </div>

                            <p className="product-name">
                                <label>
                                    {T('lto_history_detail_product_name')}{' '}
                                </label>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: item.productName,
                                    }}
                                />
                            </p>

                            <p className="specification row text-ellipsis">
                                <label>
                                    {T('lto_history_detail_package_size')}{' '}
                                </label>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: item.productSize,
                                    }}
                                />
                            </p>
                            {/* <p className="list-price row text-ellipsis">
                                <div>
                                    <label>{T('lto_history_detail_list_price')} </label>
                                    <span>{ item.listPrice }</span>
                                </div>
                            </p> */}

                            {item.displayAttributeList &&
                                item.displayAttributeList.length > 0 && (
                                    <div className="assayid-content-wrapper">
                                        {item.displayAttributeList.map(
                                            (assayIdItem, assayIdIndex) => (
                                                <div
                                                    className="assayIdArea"
                                                    key={assayIdIndex}>
                                                    <label
                                                        style={{
                                                            marginRight: '5px',
                                                        }}>
                                                        {
                                                            assayIdItem.displayName
                                                        }
                                                        :
                                                    </label>
                                                    <span className="assayIdLabel">
                                                        {
                                                            assayIdItem.displayValue
                                                        }
                                                    </span>
                                                </div>
                                            ),
                                        )}
                                    </div>
                                )}
                            {item.crd &&
                                orderType !== OrderTypeEnum.SO &&
                                orderType !== OrderTypeEnum.SE && (
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            textAlign: 'right',
                                            display: 'flex',
                                            color: '#b1b1b1',
                                        }}>
                                        <span>
                                            <span>{T('product_crd_date')}</span>
                                        </span>
                                        <span style={{marginLeft: '8px'}}>
                                            {item.crd}
                                        </span>
                                    </div>
                                )}
                        </div>
                    </Grid>
                </Grid>
                {this.props.children}
            </div>
        );
    }
}

ProductItem.defaultProps = {
    inventoryKey: 'displayInventory',
    orderType: 'SCM',
};

export default ProductItem;
